// import React, { useState } from "react";
// import {
//   Container,
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Paper,
//   Alert,
//   Stack,
//   IconButton,
//   InputAdornment,
//   CircularProgress
// } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { useNavigate, Link } from "react-router-dom";
// import ApiServices from "../../../Utils/ApiServices/ApiServices";
// import CryptoJS from "crypto-js";
// import logo from "../../../Assets/logo.png";

// const secretKey = process.env.REACT_APP_USER_ENC_DEC_KEY;

// const accent = "#0d47a1";
// const accentLight = "#e3f2fd";

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "10px",
//     backgroundColor: "#f8f9fb",
//     transition: "all 0.2s ease",
//     "&:hover": { backgroundColor: "#f0f2f5" },
//     "&.Mui-focused": {
//       backgroundColor: "#fff",
//       "& .MuiOutlinedInput-notchedOutline": {
//         borderColor: accent,
//         borderWidth: 2
//       }
//     }
//   },
//   "& .MuiInputLabel-root.Mui-focused": { color: accent }
// };

// const ClientLogin = () => {
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     business_email: "",
//     password: ""
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const encrypt = (data) =>
//     CryptoJS.AES.encrypt(data, secretKey).toString();

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       setLoading(true);
//       setError("");

//       const res = await ApiServices.post(
//         "/api/v1/clients/login/",
//         form
//       );

//       const data = res.data;

//       sessionStorage.setItem(
//         "LoginUserAccessToken",
//         encrypt(data.token)
//       );

//       sessionStorage.setItem(
//         "LoginUserRefreshToken",
//         encrypt(data.refresh)
//       );

//       sessionStorage.setItem(
//         "LoginUserID",
//         encrypt(data.client_id)
//       );
//       sessionStorage.setItem(
//         "activeClientId",
//         data.client_id
//       );

//       navigate(`/client-view/${data.client_id}/dashboard`);
//     } catch (err) {
//       const message =
//         err?.response?.data?.non_field_errors?.[0] ||
//         "Login failed";

//       setError(message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: "calc(100vh - 145px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: `linear-gradient(135deg, ${accentLight} 0%, #fff 50%, #e8eaf6 100%)`,
//         px: 2,
//         py: 4
//       }}
//     >
//       <Container maxWidth="sm" disableGutters>
//         <Paper
//           elevation={0}
//           sx={{
//             p: { xs: 3, sm: 5 },
//             borderRadius: "20px",
//             border: "1px solid #e0e0e0",
//             boxShadow: "0 8px 32px rgba(13,71,161,0.08)",
//             position: "relative",
//             overflow: "hidden",
//             "&::before": {
//               content: '""',
//               position: "absolute",
//               top: 0,
//               left: 0,
//               right: 0,
//               height: "4px",
//               background: `linear-gradient(90deg, ${accent}, #1976d2, #42a5f5)`
//             }
//           }}
//         >
//           <Stack spacing={3} alignItems="center">
//             <Box
//               component="img"
//               src={logo}
//               alt="Logo"
//               sx={{
//                 height: { xs: 48, sm: 56 },
//                 objectFit: "contain"
//               }}
//             />

//             <Box textAlign="center">
//               <Typography
//                 variant="h5"
//                 fontWeight={700}
//                 sx={{ color: accent, mb: 0.5 }}
//               >
//                 Client Portal
//               </Typography>
//               <Typography
//                 variant="body2"
//                 sx={{ color: "#78909c" }}
//               >
//                 Sign in to access your dashboard
//               </Typography>
//             </Box>

//             {error && (
//               <Alert
//                 severity="error"
//                 sx={{
//                   width: "100%",
//                   borderRadius: "10px",
//                   "& .MuiAlert-icon": { alignItems: "center" }
//                 }}
//                 onClose={() => setError("")}
//               >
//                 {error}
//               </Alert>
//             )}

//             <Box
//               component="form"
//               onSubmit={handleSubmit}
//               sx={{ width: "100%" }}
//             >
//               <Stack spacing={2.5}>
//                 <TextField
//                   label="Business Email"
//                   name="business_email"
//                   type="email"
//                   value={form.business_email}
//                   onChange={handleChange}
//                   required
//                   fullWidth
//                   sx={inputSx}
//                 />

//                 <TextField
//                   label="Password"
//                   name="password"
//                   type={showPassword ? "text" : "password"}
//                   value={form.password}
//                   onChange={handleChange}
//                   required
//                   fullWidth
//                   sx={inputSx}
//                   InputProps={{
//                     endAdornment: (
//                       <InputAdornment position="end">
//                         <IconButton
//                           size="small"
//                           onClick={() =>
//                             setShowPassword(!showPassword)
//                           }
//                           edge="end"
//                         >
//                           {showPassword ? (
//                             <VisibilityOff fontSize="small" />
//                           ) : (
//                             <Visibility fontSize="small" />
//                           )}
//                         </IconButton>
//                       </InputAdornment>
//                     )
//                   }}
//                 />

//                 <Button
//                   variant="contained"
//                   type="submit"
//                   fullWidth
//                   disabled={loading}
//                   disableElevation
//                   sx={{
//                     backgroundColor: accent,
//                     borderRadius: "10px",
//                     py: 1.4,
//                     fontSize: "0.95rem",
//                     fontWeight: 600,
//                     textTransform: "none",
//                     letterSpacing: 0.3,
//                     transition: "all 0.25s ease",
//                     "&:hover": {
//                       backgroundColor: "#0a3a82",
//                       transform: "translateY(-1px)",
//                       boxShadow: "0 4px 16px rgba(13,71,161,0.3)"
//                     },
//                     "&:active": { transform: "translateY(0)" }
//                   }}
//                 >
//                   {loading ? (
//                     <CircularProgress
//                       size={22}
//                       sx={{ color: "#fff" }}
//                     />
//                   ) : (
//                     "Sign In"
//                   )}
//                 </Button>

//                 <Stack
//                   direction="row"
//                   justifyContent="center"
//                   spacing={1}
//                   sx={{ pt: 1 }}
//                 >
//                   <Link
//                     to="/client-forgot-password"
//                     style={{
//                       color: accent,
//                       fontSize: "0.85rem",
//                       textDecoration: "none",
//                       fontWeight: 500
//                     }}
//                   >
//                     Forgot Password?
//                   </Link>

//                   <Typography
//                     variant="body2"
//                     sx={{ color: "#bdbdbd" }}
//                   >
//                     •
//                   </Typography>

//                   <Link
//                     to="/client-signup"
//                     style={{
//                       color: accent,
//                       fontSize: "0.85rem",
//                       textDecoration: "none",
//                       fontWeight: 500
//                     }}
//                   >
//                     Create Account
//                   </Link>
//                 </Stack>
//               </Stack>
//             </Box>
//           </Stack>
//         </Paper>
//       </Container>
//     </Box>
//   );
// };

// export default ClientLogin;



// existing imports remain same
import React, { useState } from "react";
import {
  Container, Box, TextField, Button, Typography, Paper, Alert, Stack,
  IconButton, InputAdornment, CircularProgress, Chip, Divider
} from "@mui/material";
import {
  Visibility, VisibilityOff, Restaurant, Campaign,
  Insights, Support, LockOutlined
} from "@mui/icons-material";
import { useNavigate, Link } from "react-router-dom";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import CryptoJS from "crypto-js";
import logo from "../../../Assets/logo.png";

const secretKey = process.env.REACT_APP_USER_ENC_DEC_KEY;
const accent = "#0d47a1";
const accentLight = "#e3f2fd";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "#f8f9fb",
    transition: "all 0.3s",
    "&:hover": { backgroundColor: "#f0f2f5" },
    "&.Mui-focused": {
      backgroundColor: "#fff",
      "& .MuiOutlinedInput-notchedOutline": { borderColor: accent, borderWidth: 2 }
    }
  },
  "& .MuiInputLabel-root.Mui-focused": { color: accent }
};

const features = [
  { icon: <Restaurant fontSize="small" />, label: "POS & Menu Management" },
  { icon: <Campaign fontSize="small" />, label: "Marketing Automation" },
  { icon: <Insights fontSize="small" />, label: "Real-Time Analytics" },
  { icon: <Support fontSize="small" />, label: "24/7 Dedicated Support" }
];

const ClientLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ business_email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const encrypt = (data) => CryptoJS.AES.encrypt(data, secretKey).toString();
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError("");
      const res = await ApiServices.post("/api/v1/clients/login/", form);
      const { token, client_id: clientId, refresh } = res.data;

      sessionStorage.setItem("LoginUserAccessToken", encrypt(token));
      sessionStorage.setItem("LoginUserRefreshToken", encrypt(refresh));
      sessionStorage.setItem("LoginUserID", encrypt(clientId));
      sessionStorage.setItem("activeClientId", clientId);

      try {
        const clientRes = await ApiServices.get(`/api/v1/clients/${clientId}/`, {
          Authorization: `Bearer ${token}`
        });
        sessionStorage.setItem("clientDetails", JSON.stringify(clientRes.data));
      } catch (clientErr) {
        console.error("Client details fetch failed", clientErr);
      }

      navigate(`/client-view/${clientId}/dashboard`);
    } catch (err) {
      setError(err?.response?.data?.non_field_errors?.[0] || "Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 145px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(160deg, ${accentLight} 0%, #ffffff 40%, #e8eaf6 100%)`,
        position: "relative",
        overflow: "hidden",
        px: 2, py: 6
      }}
    >
      {/* Decorative circles */}
      <Box sx={{
        position: "absolute", width: 300, height: 300, borderRadius: "50%",
        background: `radial-gradient(circle, ${accentLight} 0%, transparent 70%)`,
        top: -80, right: -80, opacity: 0.5
      }} />
      <Box sx={{
        position: "absolute", width: 200, height: 200, borderRadius: "50%",
        background: `radial-gradient(circle, ${accentLight} 0%, transparent 70%)`,
        bottom: -60, left: -60, opacity: 0.4
      }} />

      <Container maxWidth="sm" disableGutters sx={{ position: "relative", zIndex: 1 }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, sm: 5 },
            borderRadius: "24px",
            border: "1px solid rgba(13,71,161,0.08)",
            boxShadow: "0 12px 48px rgba(13,71,161,0.10)",
            backdropFilter: "blur(10px)",
            background: "rgba(255,255,255,0.95)"
          }}
        >
          <Stack spacing={3} alignItems="center">
            {/* Logo */}
            <Box component="img" src={logo} alt="Rite Logo" sx={{ height: { xs: 44, sm: 52 } }} />

            {/* Lock icon badge */}
            <Box sx={{
              width: 52, height: 52, borderRadius: "16px",
              background: `linear-gradient(135deg, ${accent}, #1565c0)`,
              display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: "0 4px 16px rgba(13,71,161,0.25)"
            }}>
              <LockOutlined sx={{ color: "#fff", fontSize: 26 }} />
            </Box>

            <Box textAlign="center">
              <Typography variant="h5" fontWeight={800} sx={{ color: accent }}>
                Client Portal
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={0.5}>
                Manage your restaurant, marketing &amp; analytics — all in one place.
              </Typography>
            </Box>

            {/* Feature chips */}
            <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={1}>
              {features.map((f) => (
                <Chip
                  key={f.label}
                  icon={f.icon}
                  label={f.label}
                  size="small"
                  sx={{
                    backgroundColor: accentLight,
                    color: accent,
                    fontWeight: 600,
                    fontSize: "0.72rem",
                    "& .MuiChip-icon": { color: accent }
                  }}
                />
              ))}
            </Stack>

            <Divider sx={{ width: "100%" }} />

            {error && <Alert severity="error" sx={{ width: "100%", borderRadius: "12px" }}>{error}</Alert>}

            {/* Form */}
            <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
              <Stack spacing={2.5}>
                <TextField
                  label="Business Email"
                  name="business_email"
                  value={form.business_email}
                  onChange={handleChange}
                  fullWidth required
                  sx={inputSx}
                />

                <TextField
                  label="Password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={form.password}
                  onChange={handleChange}
                  fullWidth required
                  sx={inputSx}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />

                <Box textAlign="right">
                  <Link to="/forgot-password" style={{ fontSize: "0.82rem", color: accent, textDecoration: "none", fontWeight: 600 }}>
                    Forgot password?
                  </Link>
                </Box>

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  disabled={loading}
                  sx={{
                    py: 1.5,
                    borderRadius: "12px",
                    fontWeight: 700,
                    fontSize: "1rem",
                    textTransform: "none",
                    background: `linear-gradient(135deg, ${accent}, #1565c0)`,
                    boxShadow: "0 4px 16px rgba(13,71,161,0.3)",
                    "&:hover": {
                      background: `linear-gradient(135deg, #0a3d91, ${accent})`,
                      boxShadow: "0 6px 20px rgba(13,71,161,0.4)"
                    }
                  }}
                >
                  {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Sign In to Dashboard"}
                </Button>
              </Stack>
            </Box>

            <Divider sx={{ width: "100%" }}>
              <Typography variant="caption" color="text.secondary">New to Rite?</Typography>
            </Divider>

            <Button
              component={Link}
              to="/client-signup"
              variant="outlined"
              fullWidth
              sx={{
                py: 1.3,
                borderRadius: "12px",
                fontWeight: 700,
                fontSize: "0.95rem",
                textTransform: "none",
                borderColor: accent,
                color: accent,
                borderWidth: 2,
                "&:hover": {
                  borderWidth: 2,
                  backgroundColor: accentLight,
                  borderColor: accent
                }
              }}
            >
              Create Client Account
            </Button>

            <Typography variant="caption" color="text.secondary" textAlign="center" sx={{ mt: 1 }}>
              By signing in you agree to our{" "}
              <Link to="/terms" style={{ color: accent, textDecoration: "none" }}>Terms</Link> &{" "}
              <Link to="/privacy" style={{ color: accent, textDecoration: "none" }}>Privacy Policy</Link>
            </Typography>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default ClientLogin;
